import Phaser from 'phaser'
import SizeEditor from '../editor/sizeEditor'
import Editable from './editable'
import AnimatedParticle from './animatedParticle'

export default class Cake extends Editable {
  constructor (scene, args, doSave = true) {
    super(scene, args, 'cake', doSave)
    this.bounce = false

    this.spawnX = args.x
    this.spawnY = args.y

    this.image = this.scene.matter.add.sprite(args.x, args.y, 'cake2', 0)
    this.image.setDepth(600)
    this.image.setBody({ width: 190, height: 130 }, { mass: 0.2, render: { sprite: { yOffset: 0.125 } } })

    this.image.setSize(101, 92)
    this.image.setName('cake')
    this.image.setDisplaySize(101, 92)
    this.image.parentContainer = this
    this.image.setCollisionGroup(this.scene.collisionGroup1)

    this.stoolIm = this.scene.matter.add.image(args.x, args.y + 105, 'images', 'stool')
    this.stoolIm.setDepth(550)
    this.stoolIm.setMass(0.50)
    this.stoolIm.setCollisionGroup(this.scene.collisionGroup1)
    this.stoolIm.setName('stool')

    this.finishGround = this.scene.matter.add.image(args.x, args.y + 210, 'white')
    this.finishGround.setSize(2000, 100)
    this.finishGround.setDisplaySize(2000, 100)
    this.finishGround.setStatic(true)
    this.finishGround.setVisible(false)

    this.heartIm = this.scene.add.image(args.x, args.y, 'images', 'heart')
    this.heartIm.setVisible(false)
    this.heartIm.setDepth(1000)

    // this.addHiddenProperty('x', () => { return Math.round(this.image.x) })
    // this.addHiddenProperty('y', () => { return Math.round(this.image.y) })

    this.scene.player.cake = this

    this.init(args, false)
    this.refreshPosition()

    // add some particles
    this.exploded = false
    this.confettiParticles = this.scene.add.particles('confetti')
    this.confettiParticles.setDepth(500)

    this.confetti = this.confettiParticles.createEmitter({
      on: false,
      x: 500,
      y: 300,
      tint: [0xff4444, 0xffff00, 0x4444ff, 0xff0000, 0x00ff00, 0x0000ff],
      active: true,
      // frequency: 1000,
      quantity: 75,
      lifespan: 4000,
      // angle: { min: -30, max: -60 },
      speed: { min: 750, max: 1500 },
      gravityY: 1000,
      rotate: { onEmit: function (particle, key, t, value) { return Phaser.Math.Between(0, 360) } },
      particleClass: AnimatedParticle
    })
  }

  explodeConfetti () {
    if (this.exploded) {
      return
    }

    this.confetti.setPosition(this.image.x + 50, this.image.y + 250)// this.landscape ? 0 : -500, 600)
    this.confetti.setAngle({ min: -60, max: -90 })
    this.confetti.explode()

    this.confetti.setPosition(this.image.x - 50, this.image.y + 250)// 1280, 600)
    this.confetti.setAngle({ min: -120, max: -90 })
    this.confetti.explode()

    this.exploded = true
  }

  onEdit () {
    super.onEdit()
    this.refreshPosition()
  }

  refreshPosition () {
    this.stoolIm.x = this.image.x
    this.stoolIm.y = this.image.y + 105
    this.finishGround.x = this.image.x
    this.finishGround.y = this.image.y + 210

    this.spawnX = this.image.x
    this.spawnY = this.image.y

    this.scene.spawner.finishX = this.image.x
  }

  onHit () {
    super.onHit()
    this.scene.player.onHitCake(this)
    this.explodeConfetti()

    if (this.image.body.angularVelocity === 0) {
      this.image.setAngularVelocity(0.25)
    } else {
      this.image.setAngularVelocity(this.image.body.angularVelocity * 10)
    }
  }

  delete () {
    this.heartIm.destroy()
    this.finishGround.destroy()
    this.stoolIm.destroy()
    this.scene.player.cake = null
    super.delete()
  }

  getX () {
    return this.spawnX
  }

  getY () {
    return this.spawnY
  }
}
